import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../api';
import type { Instrument } from '../instruments/useInstruments';

async function fetchCurrencies(): Promise<Instrument[]> {
  const response = await apiClient.get<Instrument[]>('/api/instruments/currencies');
  return response.data || [];
}

export function useReportingCurrencies() {
  return useQuery({
    queryKey: ['instruments', 'currencies'],
    queryFn: fetchCurrencies,
    staleTime: 300_000,
  });
}
